import * as React from "react";
import {
  Stack,
  Box,
  AppBar,
  Container,
  Button,
  IconButton,
  Typography,
  Drawer,
  List,
  ListItem,
  ListItemText,
  useMediaQuery,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { Multilanguage } from "./Multilanguage";
import { UserMenu } from "./commons/UserMenu.jsx";
import "../styles/AppBar.css";
import { Home as HomeIcon, Menu as MenuIcon, Help as HelpIcon, MenuBook as MenuBookIcon } from '@mui/icons-material';
import logoMadurez from "../images/logoMadurezDigital.png";
import { useNavigate } from "react-router-dom";
import colors from '../theme/colors'

const ResponsiveAppBar = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const isMobile = useMediaQuery("(max-width: 960px)");

  function Home() {
    navigate("/");
  }

  function FAQs() {
    navigate("/FAQs");
  }

  function Glosario() {
    navigate("/Glosario-de-terminos");
  }

  const menuItems = [
    {
      label: t("nav.Inicio").toUpperCase(),
      icon: <HomeIcon sx={{ paddingRight: 1, color: colors.primary }} />,
      onClick: Home,
    },
    {
      label: t("nav.FAQs").toUpperCase(),
      icon: <HelpIcon sx={{ paddingRight: 1, color: colors.primary }} />,
      onClick: FAQs,
    },
    {
      label: t("nav.Glosario").toUpperCase(),
      icon: <MenuBookIcon sx={{ paddingRight: 1, color: colors.primary }} />,
      onClick: Glosario,
    },
  ];

  //TODO alinear texto e icono
  return (
    <AppBar position="sticky" sx={{ backgroundColor: colors.bgLight, borderBottom: "0.2em solid " + colors.primary }}>
      <Container>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          spacing={{ xs: 2, lg: 8 }}
          sx={{
            minHeight: "8vh",
          }}
        >
          <Stack
            direction={"row"}
            spacing={1}
            sx={{ display: { xs: "none", sm: "inherit" } }}
          > 
            <a target="_blank" href="https://ipyme.org">
              <img
                src="https://paeelectronico.es/PublishingImages/Logo/Logo-Direccion-IPYME.png"
                className={"logo"}
                alt="Logo Direccion IPYME"
              />
            </a>
          </Stack>

        {isMobile ? (
          <Stack direction={"row"} alignItems={"center"} spacing={1}>
            <IconButton
              aria-label="Menu"
              onClick={() => setIsMenuOpen(true)}
            >
              <MenuIcon sx={{ color: colors.primary }} />
            </IconButton>

            <Drawer
              anchor="top"
              open={isMenuOpen}
              onClose={() => setIsMenuOpen(false)}
            >
              <Box
                sx={{ bgcolor: colors.textMain, color: colors.primary }}
                role="presentation"
                onClick={() => setIsMenuOpen(false)}
                onKeyDown={() => setIsMenuOpen(false)}
              >
                <List>
                  {menuItems.map((item) => (
                    <ListItem key={item.label} onClick={item.onClick}>
                      {item.icon}
                      <ListItemText primary={item.label} />
                    </ListItem>
                  ))}
                </List>
              </Box>
            </Drawer>
            <Box sx={{ flexGrow: 1, zIndex: "99" }}>
              <Multilanguage />
            </Box>
            <Box sx={{ flexGrow: 1, zIndex: "99" }}>
              <UserMenu />
            </Box>
          </Stack>
        ) : (
          <Stack direction={"row"} alignItems={"center"} spacing={1}>
            <Box>
              <Button
                onClick={() => {
                  Home();
                }}
                variant="text"
                aria-label="Inicio"
                color="text"
              >
                <Stack direction="row" spacing={1} alignItems="center">
                  <HomeIcon sx={{ color: colors.primary }}
                  />
                  <Typography variant="parrafoPrimary" lineHeight="1">{t("nav.Inicio")}</Typography>
                </Stack>
              </Button>
            </Box>

            <Box sx={{ flexGrow: 0, zIndex: "99" }}>
              <Button
                onClick={() => {
                  FAQs();
                }}
                variant="text"
                aria-label="FAQs"
                color="text"
              >
                <Stack direction={"row"} alignItems={"center"} spacing={1}>
                  <HelpIcon sx={{ color: colors.primary }}
                  />
                  <Typography variant="parrafoPrimary" lineHeight="1">
                    {t("nav.FAQs")}
                  </Typography>
                </Stack>
              </Button>
            </Box>

            <Box sx={{ flexGrow: 0, zIndex: "99" }}>
              <Button
                onClick={() => {
                  Glosario();
                }}
                variant="text"
                aria-label="Glosario"
                color="text"
              >
                <Stack direction={"row"} alignItems={"center"} spacing={1}>
                  <MenuBookIcon sx={{ color: colors.primary }} />
                  <Typography variant="parrafoPrimary" lineHeight="1">
                    {t("nav.Glosario")}
                  </Typography>
                </Stack>
              </Button>
            </Box>

            <Box sx={{ flexGrow: 0, zIndex: "99" }}>
              <Multilanguage />
            </Box>

            <Box sx={{ flexGrow: 0, zIndex: "99" }}>
              <UserMenu />
            </Box>
          </Stack>
        )}

          <Stack
            direction={"row"}
            spacing={1}
            sx={{ display: { xs: "none", sm: "inherit" } }}
          >
            <a href="/">
              <img
                src={logoMadurez}
                className={"logoAEC"}
                width={'80px'}
                alt="Logo Autodiagnóstico de Madurez Digital"
              />
            </a>
          </Stack>
        </Stack>
      </Container>
    </AppBar>
  );
};
export default ResponsiveAppBar;
